import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { MasterParamDetailForm } from "@/features/master-param/MasterParamDetailForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function MasterParamDetail() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/master-param",
            label: "Master Param",
          },
          {
            label: "Detail",
          },
        ]}
      />
      <H2>Master Param Detail</H2>
      <MasterParamDetailForm id={id} />
    </>
  );
}
